export default "__VITE_ASSET__DkSt9MPM__"